<template>
  <div class="sn-f-b-s case">
    <sn-navigator id="BLCX" :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s case-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', initial) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 case-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ caseType === '1' ? '就诊人' : '住院人' }}：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到{{ caseType === '1' ? '就诊人' : '住院人' }}，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <div v-else-if="patientArray.length === 0" @click="navigateUrl(caseType === '1' ? 'addition-patient' : '/patient/out/homepage');">
              暂无{{ caseType === '1' ? '就诊人' : '住院人' }}，<span class="sn-pointer sn-fc-main">点击添加</span>
            </div>
            <template v-else>
              <el-select class="name" :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>
          <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : ['就诊卡', '住院号'][caseType - 1] }}：</div>
            </div>
            <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
              {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
            </div>
            <div v-else>
              <el-input class="card" readonly="readonly" v-model="outCardSerialFormat"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>日期范围：</div>
            </div>
            <el-date-picker class="range"
            start-placeholder="开始日期" end-placeholder="结束日期" type="daterange"  value-format="yyyy-MM-dd"
            v-model="dateRange" :editable="false" :clearable="false"></el-date-picker>
          </div>
          <div class="sn-f-c-c sn-pointer interaction"
          :class="{'sn-silence': !selectedPatient.patientId || !outCardSerial || dateRange.length !== 2}" @click="searchBtn();">查询</div>
        </div>
        <template v-if="!$sn.validate.empty(handleCase)">
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>患者姓名</th>
                  <th>医生姓名</th>
                  <th>就诊科室</th>
                  <th>就诊时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(el, index) in handleCase">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{el.doctorName}}</td>
                  <td>{{el.deptName}}</td>
                  <td>{{el.schDate}}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/case/detail', el, {type: caseType});">查看详情</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <div class="sn-f-c-c prompt-message">列表仅显示两个月内病历记录、更多记录请按时间筛选查询</div>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(caseInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" :type="isOpenSingleCard ? '1' : caseType" @sendBack="sendBackBindCard"></bind-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  data() {
    return {
      caseType: '1', // 1:门诊 2:住院
      patientArray: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      caseInfo: [],
      caseArray: [],
      dateRange: [
        self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -(self.$sn.getConfig('reportSearchDateRange').split(',')[1]), self.$sn.getConfig('reportSearchDateRange').split(',')[2]),
        self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')
      ],
      pageCount: 1,
      isResult: true,
      exhibitionCreatePatient: false,
      exhibitionBindCard: false,
      isOpenSingleCard: self.$sn.getConfig('isOpenSingleCard')
    };
  },
  computed: {
    // 处理病历信息
    handleCase() {
      let handle = [];
      if (this.caseInfo.length > 0) handle = this.$sn.format.group(this.caseInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    },
    // 当前功能 ID
    initial() {
      return [this.perpetual.FUNCTION_ID_MZBLCX, this.perpetual.FUNCTION_ID_ZYBLCX][this.caseType - 1];
    }
  },
  watch: {
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.caseInfo = [];
      this.pageCount = 1;
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient, this.caseType);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) this.outCardSerialFormat = patient.idCardEncrypt;
        }
        if (this.outCardSerial) {
          // 门诊
          if (this.caseType === '1') this.searchBtn();
        }
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043',
            [this.perpetual.HOSPITAL_ID_SDQL]: 'PATIENT036'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) this.navigateUrl('addition-card');
            }
          });
        }
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.caseInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.paginateResult();
        }
      },
      immediate: true
    },
    dateRange: {
      handler: function() {
        this.caseInfo = [];
      },
      deep: true
    },

    $route(val, old) {
      if ((old.path === '/query/case' && val.path !== '/query/case/detail') || (old.path === '/query/case/detail' && val.path !== '/query/case')) {
        this.funLoad();
      }
      else if (old.path === '/query/case/detail' && val.path === '/query/case') {
        if (this.caseType !== this.$route.query.type) this.funLoad();
      }
    }
  },
  created: function() {
    this.funLoad();
  },
  methods: {
    funLoad() {
      this.caseType = this.$route.query.type || '1';
      document.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.handlePatientInfo();
    },
    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.caseType === '2') {
        // 住院人 - 含有住院号
        if (!this.isOpenSingleCard) {
          this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
        }
      }
      if (this.patientArray && this.patientArray.length > 0) {
        if (this.caseType === '1') this.selectedPatient = this.$sn.utils.getCurrentPatient();
        else {
          if (this.isOpenSingleCard) this.selectedPatient = this.$sn.utils.getCurrentPatient() || this.patientArray[0];
          else this.selectedPatient = this.patientArray.find(item => item.inCardNo) || this.patientArray[0];
        }
      }
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询病历信息
    searchBtn() {
      if (!this.selectedPatient.patientId || !this.outCardSerial || this.dateRange.length !== 2) return false;
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
        const params = {
          url: this.$sn.format.caption(Swagger.getSpecialCaseTable, [this.$sn.utils.getHospitalId()]),
          query: {
            platformId: this.$sn.utils.getPlatformType(),
            platformUserId: this.$sn.utils.getOpenId(),
            patId: this.selectedPatient.patientId,
            startDate: this.dateRange[0],
            endDate: this.dateRange[1]
          },
          header: true
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          this.isResult = true;
          if (result && result.code === 0) {
            if (result.data && result.data.length > 0) {
              this.caseArray = result.data;
              this.paginateResult();
            }
          }
          else this.getShowToast(result?.msg || Messages.C001);
        });
      }
    },
    // 分页
    paginateResult() {
      const start = (this.pageCount - 1) * this.perpetual.PAGINATION_SIZE;
      const end = this.pageCount * this.perpetual.PAGINATION_SIZE;
      if (this.isResult) this.caseInfo = this.caseArray;
      if (this.caseArray.slice(start, end).length < this.perpetual.PAGINATION_SIZE) this.isResult = false;
      if (this.caseArray.slice(start, end).length === 0) this.isResult = false;
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.caseInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/query/case/detail' && !this.$sn.validate.empty(item)) {
        this.$sn.utils.setHospitalSessionStorage('Query_CaseReportInfo', {
          ...item,
          patient: this.selectedPatient
        });
      }
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.case {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .case-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
